import AuthenticatedPage from '../../components/authenticated-page';
import SearchPodcasts from '../../components/search-podcasts';
import { usePageTitle } from '../../utils/page-title';

const Search = () => {
  usePageTitle('Search');
  return (
    <AuthenticatedPage>
      <section class="top-section">
        <h1 class="mb-3 text-center text-xl">Search Podcasts</h1>
        <SearchPodcasts />
      </section>
    </AuthenticatedPage>
  );
};

export default Search;
